const TARGET_TICK_COUNT = 8;

export const buildTickLabelInterval = (
  totalPoints: number,
): ((value: string, index: number) => boolean) | 'auto' => {
  if (totalPoints <= TARGET_TICK_COUNT) return 'auto';
  const step = Math.ceil((totalPoints - 1) / (TARGET_TICK_COUNT - 1));
  return (_value: string, index: number) =>
    index === 0 || index === totalPoints - 1 || index % step === 0;
};
